module.exports = __webpack_public_path__ + "img/royal.fac6232c.png";